__turbopack_context__.v({
  "active": "styles-module-scss-module__lIvNda__active",
  "advanced_search_link": "styles-module-scss-module__lIvNda__advanced_search_link",
  "category_items": "styles-module-scss-module__lIvNda__category_items",
  "category_items_partial_street_search": "styles-module-scss-module__lIvNda__category_items_partial_street_search",
  "category_label": "styles-module-scss-module__lIvNda__category_label",
  "headline_container": "styles-module-scss-module__lIvNda__headline_container",
  "hidden": "styles-module-scss-module__lIvNda__hidden",
  "no_result": "styles-module-scss-module__lIvNda__no_result",
  "pseudo_focus": "styles-module-scss-module__lIvNda__pseudo_focus",
  "quick_link": "styles-module-scss-module__lIvNda__quick_link",
  "quick_link_container": "styles-module-scss-module__lIvNda__quick_link_container",
  "search_bar": "styles-module-scss-module__lIvNda__search_bar",
  "search_button": "styles-module-scss-module__lIvNda__search_button",
  "search_button_container": "styles-module-scss-module__lIvNda__search_button_container",
  "search_container": "styles-module-scss-module__lIvNda__search_container",
  "search_dropdown": "styles-module-scss-module__lIvNda__search_dropdown",
  "search_filters": "styles-module-scss-module__lIvNda__search_filters",
  "tab_container": "styles-module-scss-module__lIvNda__tab_container",
});
